import { FccAdAlertStatus, FccAdAlertType } from '@backoffice-frontend/graphql'
import { ServiceCancellationInitiatedAction } from '../../../ServiceCancellation/ServiceCancellationProvider'
import { useServiceCancellation } from '../../../ServiceCancellation/useServiceCancellation'
import type { AdVehicleStreamVehicleFragment } from '../../AdVehicleStream.hook'
import { EmergencyStopActionCard } from '../EmergencyStopActionCard'
import { ServiceCancellationActionCard } from '../ServiceCancellationActionCard/ServiceCancellationActionCard'
import { SingleTripCancellationActionCard } from '../SingleTripCancellationActionCard/SingleTripCancellationActionCard'

type ServiceManagementActionCardProps = {
  vehicle: AdVehicleStreamVehicleFragment
}

export const ServiceManagementActionCard = ({
  vehicle,
}: ServiceManagementActionCardProps) => {
  const { initiatedAction } = useServiceCancellation()

  const alerts = vehicle.fccOperatorAdAlerts?.alerts ?? []

  const hasEmergencyStopAlert = alerts.some(
    a =>
      a.type === FccAdAlertType.EmergencyStop &&
      a.status !== FccAdAlertStatus.Closed,
  )
  const hasServiceCancellationAlert = alerts.some(
    a =>
      a.type === FccAdAlertType.ServiceCancellationOngoing &&
      a.status !== FccAdAlertStatus.Closed,
  )
  const hasTripCancellationAlert = alerts.some(
    a =>
      a.type === FccAdAlertType.TripCancellationOngoing &&
      a.status !== FccAdAlertStatus.Closed,
  )

  if (
    initiatedAction === ServiceCancellationInitiatedAction.TripManagement &&
    hasTripCancellationAlert
  ) {
    return <SingleTripCancellationActionCard vehicle={vehicle} />
  }

  if (
    initiatedAction === ServiceCancellationInitiatedAction.ContinueService &&
    hasEmergencyStopAlert
  ) {
    return <EmergencyStopActionCard vehicle={vehicle} />
  }

  if (
    (initiatedAction === ServiceCancellationInitiatedAction.RestoreMission ||
      initiatedAction === ServiceCancellationInitiatedAction.CancelService) &&
    hasServiceCancellationAlert
  ) {
    return <ServiceCancellationActionCard vehicle={vehicle} />
  }

  if (hasTripCancellationAlert) {
    return <SingleTripCancellationActionCard vehicle={vehicle} />
  }

  if (hasEmergencyStopAlert) {
    return <EmergencyStopActionCard vehicle={vehicle} />
  }

  return <ServiceCancellationActionCard vehicle={vehicle} />
}
